import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { MotifTable, MotifTextLink, MotifIcon } from '@ey-xd/motif-react';
import { contentIcAddCircle24px } from '@ey-xd/motif-react/assets/icons';
import {
  TableData1BDark,
  TableData1C,
  TableData3DotStyle,
  TableData1CDark,
} from '../../../../atoms/gcsp/gcspTable.styles';
import { Gcsp_Past_Opp_View_State } from '../../../../../recoil/recoil';
import { useRecoilState } from 'recoil';
import { formateTOV } from '../../../../../util/commonUtil';

const GcspPastTableData = ({ refValue }) => {
  const [pageSize, setPageSize] = useState('4');
  const bottomGrid = useRef(null);
  const handleUploadImage = value => {
    alert(value);
  };

  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Past_Opp_View_State);

  let rowData = [];
  if (gcspOppViewData.length !== 0) {
    const rowDataTotalForecasted = gcspOppViewData.PL_Total_Forecasted.map(data => ({
      ...data,
      background: '#3A3A4A',
    }));

    const rowDataTotalYourJudge = gcspOppViewData.Your_Judge.map(data => ({
      ...data,
      background: '#3A3A4A',
    }));
    const rowDataTotalCommit = gcspOppViewData.Total_Forecasted.map(data => ({
      ...data,
      background: '#3A3A4A',
    }));
    const rowDataActualSold = gcspOppViewData.Actual_Sold.map(data => ({
      ...data,
      background: '#1A1A2A',
    }));
    const rowDataAccuarcy = gcspOppViewData.Accuracy.map(data => ({
      ...data,
      background: '#1A1A2A',
    }));
    rowData = rowDataTotalForecasted.concat(
      rowDataTotalYourJudge,
      rowDataTotalCommit,
      rowDataActualSold,
      rowDataAccuarcy,
    );
  }

  const CommentColumnRenderer = ({ value }) => (
    <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
      <div>
        <MotifTextLink variant="alt" href="#">
          {value}
        </MotifTextLink>
        <span style={{ margin: '3px' }}> </span>
        <MotifIcon src={contentIcAddCircle24px} onClick={handleUploadImage} />
      </div>
    </div>
  );

  const ColumnHeaderRenderer = ({ value, data }) => {
    const keyToText = {
      'PL Total Forecasted': { main_text: 'PL Total Forecasted', sub_text: '(All Committed)' },
      'Your Judge': { main_text: 'Your Judge', sub_text: '' },
      'Your Total Forecasted': {
        main_text: 'Your Total Commit',
        sub_text: '(All Committed + Your Judge)',
      },
      'ACTUAL SOLD': { main_text: 'Actual Sold', sub_text: '(All Won)' },
      Accuracy: { main_text: 'PL Accuracy', sub_text: '(Your Forecasted vs Actual)' },
    };
    const category = data.category;
    const main_displayText = keyToText[category].main_text || '';
    const sub_displayText = keyToText[category].sub_text || '';

    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <TableData1BDark>
          <span>{main_displayText}</span>
        </TableData1BDark>
        <TableData1CDark>
          <span>{sub_displayText}</span>
        </TableData1CDark>
      </div>
    );
  };

  const OnlyCommittedRenderer = ({ value, data }) => {
    let dynamicBackgroundColor = '#168736';
    const keyToText = {
      'Total Forecasted': 'Only Committed',
    };
    const category = data.category;
    const displayText = keyToText[category] || '';

    return (
      <TableData1C>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {displayText && <TableData3DotStyle backgroundColor={dynamicBackgroundColor} />}
          {displayText && <span>{displayText}</span>}
        </div>
      </TableData1C>
    );
  };

  const TextCellRendererC = props => {
    const { value, data, KeyName } = props;
    if (value === null) {
      return <TableData1CDark>&nbsp;</TableData1CDark>;
    }

    if (props.rowIndex > 2) {
      if (props.rowIndex === 4) {
        return <TableData1BDark>{value}%</TableData1BDark>;
      } else {
        return <TableData1BDark>{formateTOV(value)}</TableData1BDark>;
      }
    } else {
      return <TableData1CDark>{formateTOV(value)}</TableData1CDark>;
    }
  };

  TextCellRendererC.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };
  const cellTextAligment = { display: 'flex', justifyContent: 'flex-end' };
  const columnDefs = [
    {
      headerName: 'ColumnHeader',
      width: 1245,
      cellRenderer: ColumnHeaderRenderer,
    },
    {
      headerName: 'Assurance',
      field: 'Assurance',
      width: 175,
      id: 1,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
      // cellStyle: { justifyContent: 'flex-end' }
    },
    {
      headerName: 'Consulting',
      field: 'consulting',
      width: 175,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
    },
    {
      headerName: 'SAT',
      field: 'sat',
      width: 175,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
    },
    {
      headerName: 'Tax',
      field: 'tax',
      width: 175,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
    },
    {
      headerName: 'IITS',
      field: 'itts',
      width: 175,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
    },
    {
      headerName: 'EMIA ACR',
      field: 'EMIAACR',
      width: 175,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
    },
    {
      headerName: 'TOV',
      field: 'TOV',
      width: 175,
      cellRenderer: TextCellRendererC,
      cellStyle: { justifyContent: 'flex-end' },
    },
  ];

  const getRowStyle = params => {
    return { background: params.data.background, border: params.data.background };
  };

  return (
    <div style={{ maxWidth: 1920, height: 236 }}>
      <MotifTable
        ref={bottomGrid}
        alignedGrids={[refValue.current]}
        columnDefs={columnDefs}
        rowData={rowData}
        components={{
          commentColumnRenderer: CommentColumnRenderer,
          textCellRendererC: TextCellRendererC,
        }}
        headerHeight={0}
        getRowStyle={getRowStyle}
        // domLayout="autoHeight"
        overlayNoRowsTemplate="Loading..."
      />
    </div>
  );
};

export default GcspPastTableData;
